import { createSlice } from '@reduxjs/toolkit';

const periodSlice = createSlice({
  name: 'period',
  initialState: {
    startDate: '',
    endDate: '',
  },
  reducers: {
    setPeriod: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    clearPeriod: (state) => {
      state.startDate = '';
      state.endDate = '';
    },
  },
});

export const { setPeriod, clearPeriod } = periodSlice.actions;
export default periodSlice.reducer;
